import React, { Component } from 'react';
import FileSaver from 'file-saver';
import { connect } from 'react-redux';
import { openModal } from 'actions/modalActions';
import { mapAccountsToGroups } from 'actions/accountsActions';
import { filenamify } from 'utils/generic';
import { v4 as uuid } from 'uuid';
import OpenCF from 'components/imports/OpenCF';
import ImportAccounts from 'components/imports/ImportAccounts';
import ImportGroups from 'components/imports/ImportGroups';
import { JournalLabel } from 'constants/labels';

class Toolbar extends Component {
  render() {
    return (
      <div className="toolbar">
        <button
          className="btn"
          onClick={() =>
            this.props.openModal({
              id: uuid(),
              type: 'component',
              componentType: 'ClientModal',
            })
          }
        >
          {this.props.state.client.name}
        </button>
        <span className="separator"></span>
        <button
          className="btn"
          onClick={() => {
            let blob = new Blob([JSON.stringify(this.props.state)], {
              type: 'text/plain;charset=utf-8',
            });
            FileSaver.saveAs(
              blob,
              `${filenamify(this.props.state.client.name)}.cf`
            );
          }}
        >
          Save CF
        </button>
        <OpenCF label="Open CF" id="opencf" />
        <span className="separator"></span>
        <button
          className="btn"
          onClick={() =>
            this.props.openModal({
              id: uuid(),
              type: 'component',
              componentType: 'PeriodsModal',
            })
          }
        >
          Periods
        </button>
        <span className="separator"></span>
        <ImportAccounts
          openModal={this.props.openModal}
          id="import"
          label="Import Accounts"
        />
        <ImportGroups
          openModal={this.props.openModal}
          id="importGroups"
          label="Import Groups"
        />
        <button
          className="btn"
          onClick={() =>
            this.props.openModal({
              id: uuid(),
              type: 'confirmation',
              text: 'Are you sure you want to map accounts to groups?',
              onConfirm: () => {
                this.props.mapAccountsToGroups();
              },
            })
          }
        >
          Map Accounts to Groups
        </button>
        <span className="separator"></span>
        <button
          className="btn"
          onClick={() =>
            this.props.openModal({
              id: uuid(),
              type: 'component',
              componentType: 'ConsolidationsModal',
            })
          }
        >
          Consolidations
        </button>
        <span className="separator"></span>
        <button
          className="btn"
          onClick={() =>
            this.props.openModal({
              id: uuid(),
              type: 'component',
              data: { journalEntryId: -1, type: 'aje' },
              componentType: 'JournalEntryModal',
            })
          }
        >
          {JournalLabel.aje.full}
        </button>
        <button
          className="btn"
          onClick={() =>
            this.props.openModal({
              id: uuid(),
              type: 'component',
              data: { journalEntryId: -1, type: 'rje' },
              componentType: 'JournalEntryModal',
            })
          }
        >
          {JournalLabel.rje.full}
        </button>
        <button
          className="btn"
          onClick={() =>
            this.props.openModal({
              id: uuid(),
              type: 'component',
              data: { journalEntryId: -1, type: 'cje' },
              componentType: 'JournalEntryModal',
            })
          }
        >
          {JournalLabel.cje.full}
        </button>
        <span className="separator"></span>
        <button
          className="btn"
          onClick={() =>
            this.props.openModal({
              id: uuid(),
              type: 'component',
              data: { kpiEntryId: -1 },
              componentType: 'KpiEntryModal',
            })
          }
        >
          Add KPI
        </button>
      </div>
    );
  }
}

export default connect(
  function mapStateToProps(state) {
    /*
    return {
      modals: state.modals
    };
    */
    // TODO: toolbar is having access to whole state only because of Save CF function - remove if not needed or refactor it out of toolbar
    return {
      state,
    };
  },
  {
    openModal,
    mapAccountsToGroups,
  }
)(Toolbar);
